/**
 * API Client
 * This class instantiates and exports the api http client.
 * This exported instance should be used by the various api services.
 */
import Axios from 'axios'

import * as Env from 'core/env'

/**
 * API client to be used in projects.
 * An Axios HTTP client configured with with settings needed to communicate with the Luminopia API.
 */
export default Axios.create({
  baseURL: Env.API_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 30000,
  withCredentials: false,
})

export interface IValidationError {
  key: string // parameter name
  path: string // dot notation path for nested parameters
  message: string // error message (e.g. `"\"email\" must be a valid email"`)
  type: string // data type
  constraint: string // failed constraint (e.g. `"required"`)
}

/**
 * Expected structure for a validation error response body
 */
export interface IValidationErrorResponseBody {
  statusCode: number
  error: string
  message: string
  validation: {
    source: string,
    errors: IValidationError[],
  }
}

/**
 * Type check whether the response is an IValidationErrorResponse.
 * This is useful for a check against the response body immediately after a response from the server comes back
 * to check whether it was a parameter validation error.
 */
export const isValidationErrorResponse =
  (error: any | IValidationErrorResponseBody): error is IValidationErrorResponseBody => {
    return !!(
      error &&
      (<IValidationErrorResponseBody> error).validation &&
      (<IValidationErrorResponseBody> error).validation.errors
    )
  }

/**
 * Converts `IValidationError`s to redux-form errors which can be directly passed to `stopSubmit`.
 * WARNING: This assumes that the validation error keys match the form field keys.
 * @param errors
 */
export const validationErrorsToReduxFormErrors = (errors: IValidationError[]) => {
  return errors.reduce((memo, err) => ({
    ...memo,
    [err.key]: err.message,
  }), {})
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/client.ts